// extracted by mini-css-extract-plugin
export default {"crossButton":"CrossButton_crossButton__lJD5E","crossIcon":"CrossButton_crossIcon__NZDrQ","placeHolderShimmer":"CrossButton_placeHolderShimmer__IQOAO"};